<template>
  <div>
    <SearchableTable
      :panel-header="'Ärzte'"
      :panel-route="'AddDoctor'"
      :show-search-bar="true"
      :table-data="doctors"
      :table-meta-data="tableMetaData"
      :query-string="'setSearchQuery'"
      :initial-search-query="searchQuery"
      :row-click="triggerView"
      :event-value="parentEventValue"
    />
  </div>
</template>

<script>
/**
 * This file shows all currently stored doctors and allows adding and
 * viewing them; editing and deleting happens on the view page.
 */
import { mapGetters } from "vuex";
import SearchableTable from "@/components/helperComponents/SearchableTable.vue";

export default {
	name: "DoctorTable",
	components: { SearchableTable },
	data() {
		return {
			parentEventValue: undefined,
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Name", "field": "name", "sortField": "attributes.name" },
				{ "id": 1, "type": "ref", "label": "Spezialisierung", "field": "specialization", "sortField": "attributes.specialization.attributes.specialization", "refName": "specialization" },
				{ "id": 2, "type": "string", "label": "Straße, Nr.", "field": "street", "sortField": "attributes.street" },
				{ "id": 3, "type": "string", "label": "PLZ", "field": "plz", "sortField": "attributes.plz" },
				{ "id": 4, "type": "string", "label": "Ort", "field": "location", "sortField": "attributes.location" },
			]
		};
	},
	computed: {
		...mapGetters({
			doctors: "getDoctor",
			searchQuery: "getSearchQuery"
		})
	},
	methods: {
		triggerView(element) {
			this.$router.push(
				{ name: "ViewDoctor", params: { id: element.id, data: element } });
		}
	},
};

</script>

<style scoped></style>
